module.exports = __webpack_public_path__ + "fonts/Rubik-300-arabic58.d2ec738.woff2";